import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ShoppingListForm from "./ShoppingListForm";
import api from "../../../services/api";
import { useSnackbarAlert } from "../../../hooks/useSnackbarAlert";

const ShoppingListFormWrapper = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const snackbar = useSnackbarAlert();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/admin/shopping-lists/${id}`);
        setData(res.data);
      } catch {
        snackbar.error("Failed to load list.");
      }
    };
    fetchData();
  }, [id]);

  if (!data) return <CircularProgress />;
  return <ShoppingListForm initialData={data} />;
};

export default ShoppingListFormWrapper;
